module.exports = __webpack_public_path__ + "static/media/account_signup_v2.983d37e0.jpeg";